import { Component } from "react";
import Pagination from "react-js-pagination";
import * as searchTopicActions from "../../redux/actions/searchTopicActions";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SearchItem from "./SearchItem";
import $ from "jquery";
import config from "../../config/config";
var Constants = require("../constants.json");

class SearchContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchkey: props.searchkey,
      searchgenus: props.searchgenus,
      respHasErr: false,
      viewTopicData: [],
      hasLoaded: false,
      topicCount: 0,
      activePage: 1,
      searchUrl: "",
      totalPages: 0,
      updatePage: true,
      scrollSource: null,
      perPage: Constants["perPageItem"] || 10,
    };
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handlePageChange(pageNumber, source) {
    this.setState({ activePage: pageNumber, scrollSource: source }, () => {
      const from = (this.state.activePage - 1) * this.state.perPage;
      this.props.searchTopic(this.state.searchUrl, from);
    });
  }

  componentDidMount() {
    const baseURL = `${config.BASE_URL}search`;
    const from = (this.state.activePage - 1) * this.state.perPage;
    this.setState({ searchUrl: baseURL }, () => {
      this.props.searchTopic(this.state.searchUrl, from);
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.hasErrored) {
      if (nextProps.errorResponse["status"] === 302) {
        nextProps.hasErrored = false;
      }
      return {
        respHasErr: true,
        error: nextProps.errorResponse["message"],
        hasLoaded: true,
        updatePage: true,
      };
    } else {
      if (
        nextProps.searchkey !== prevState.searchkey ||
        nextProps.searchgenus !== prevState.searchgenus
      ) {
        const baseURL = `${config.BASE_URL}search`;
        return {
          activePage: 1,
          searchUrl: baseURL,
          updatePage: false,
          searchkey: nextProps.searchkey,
          searchgenus: nextProps.searchgenus,
        };
      } else {
        if (
          !Array.isArray(nextProps.getTopicSearchData) &&
          Object.keys(nextProps.getTopicSearchData).length > 0
        ) {
          const totalHits = nextProps.getTopicSearchData?.hits?.total.value;
          const totalPages = Math.ceil(totalHits / prevState.perPage) || 1;
          return {
            respHasErr: false,
            viewTopicData: nextProps.getTopicSearchData,
            topicCount: totalHits,
            totalPages: totalPages,
            hasLoaded: true,
          };
        }
      }
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    const from = (this.state.activePage - 1) * this.state.perPage;
    const isNewSearch =
      prevProps.searchkey !== this.props.searchkey ||
      prevProps.searchgenus !== this.props.searchgenus;
    const isPageChange = prevState.activePage !== this.state.activePage;

    if (isPageChange || isNewSearch) {
      this.props.searchTopic(this.state.searchUrl, from);
    }
    if (
      isNewSearch ||
      (this.state.scrollSource === "bottom" &&
        this.props.getTopicSearchData !== prevProps.getTopicSearchData)
    ) {
      if ($(window).scrollTop() > 0) {
        $("html, body").animate(
          {
            scrollTop: $(".searchtopics").offset().top,
          },
          2000
        );
      }
      this.setState({ scrollSource: null });
    }
  }

  render() {
    let topicData = this.state.viewTopicData;
    return (
      <div className="search-result">
        <p className="search-result-heading">
          {this.state.topicCount > 0
            ? `${this.state.topicCount} Matching Topics`
            : "No Results Found"}
        </p>
        {this.state.topicCount > 0 ? (
          <div>
            <div className="pagination-before pag-before">
              of <b>{this.state.totalPages}</b> pages
            </div>
            <Pagination
              activePage={this.state.activePage}
              itemsCountPerPage={this.state.perPage}
              totalItemsCount={this.state.topicCount}
              pageRangeDisplayed={this.state.totalPages}
              hideFirstLastPages={true}
              linkClass={"pageNum"}
              linkClassPrev={"pagePrev"}
              linkClassNext={"pageNext"}
              onChange={(pageNumber) =>
                this.handlePageChange(pageNumber, "top")
              }
            />
            <SearchItem
              topicDetail={topicData.hits?.hits || []}
              searchkey={this.props.searchkey}
            />
            <div className="pagination-before">
              of <b>{this.state.totalPages}</b> pages
            </div>
            <Pagination
              activePage={this.state.activePage}
              itemsCountPerPage={this.state.perPage}
              totalItemsCount={this.state.topicCount}
              pageRangeDisplayed={this.state.totalPages}
              hideFirstLastPages={true}
              linkClass={"pageNum"}
              linkClassPrev={"pagePrev"}
              linkClassNext={"pageNext"}
              onChange={(pageNumber) =>
                this.handlePageChange(pageNumber, "bottom")
              }
            />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

SearchContent.propTypes = {
  searchTopic: PropTypes.func.isRequired,
  searchkey: PropTypes.string,
  searchgenus: PropTypes.string,
  hasErrored: PropTypes.bool,
  errorResponse: PropTypes.object,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  searchTopic: (searchTopicURL, from) =>
    dispatch(
      searchTopicActions.fetchTopicDataFromServices(
        searchTopicURL,
        "getTopicData",
        ownProps.searchkey,
        ownProps.searchgenus,
        from
      )
    ),
});

const mapStateToProps = (state) => ({
  getTopicSearchData: state.topicSearch,
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchContent);
